import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  margin-top: ', 'px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 500;\n  letter-spacing: -0.008em;\n  margin-top: ', 'px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.006em;\n  margin-top: ', 'px;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: ', 'px;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n  text-transform: uppercase;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: 600;\n  margin-top: ', 'px;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n'], ['\n  ', ' color: ', ';\n  font-weight: normal;\n  margin-top: ', 'px;\n']);

import { css } from 'styled-components';

import * as colors from './colors';
import { gridSize, fontSize } from './index';

var baseHeading = function baseHeading(size, lineHeight) {
  return '\n  font-size: ' + size / fontSize() + 'em;\n  font-style: inherit;\n  line-height: ' + lineHeight / size + ';\n';
};

export var h900 = function h900() {
  return css(_templateObject, baseHeading(35, 40), colors.heading, gridSize() * 6.5);
};

export var h800 = function h800() {
  return css(_templateObject2, baseHeading(29, 32), colors.heading, gridSize() * 5);
};

export var h700 = function h700() {
  return css(_templateObject, baseHeading(24, 28), colors.heading, gridSize() * 5);
};

export var h600 = function h600() {
  return css(_templateObject3, baseHeading(20, 24), colors.heading, gridSize() * 3.5);
};

export var h500 = function h500() {
  return css(_templateObject4, baseHeading(16, 20), colors.heading, gridSize() * 3);
};

export var h400 = function h400() {
  return css(_templateObject5, baseHeading(14, 16), colors.heading, gridSize() * 2);
};

export var h300 = function h300() {
  return css(_templateObject6, baseHeading(12, 16), colors.heading, gridSize() * 2.5);
};

export var h200 = function h200() {
  return css(_templateObject7, baseHeading(12, 16), colors.subtleHeading, gridSize() * 2);
};

export var h100 = function h100() {
  return css(_templateObject8, baseHeading(12, 16), colors.subtleHeading, gridSize() * 2);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/datetime-picker/node_modules/@atlaskit/theme/dist/esm/typography.js
// module id = 1287
// module chunks = 0